export { CategoriesV2Container as CategoriesV2 } from './container';
